export const getPosition = ({latitude: lat, longitude: lng}) => ({lat, lng});
